import React from "react";
import WarehouseLedger from "./warehouse-ledger";
import { fetchWarehouseRegister } from "./warehouse-api";
import { normalizeRegisterRow } from "./warehouse-utils";

const COLUMNS = [
  { key: "tovName", title: "Товар", dataIndex: "tovName", width: 320, ellipsis: true },
  { key: "funit", title: "Ед.", dataIndex: "funit", width: 70 },
  { key: "kolBeg", title: "На начало", dataIndex: "kolBeg", width: 120, align: "right", type: "number" },
  { key: "kolPut", title: "Приход", dataIndex: "kolPut", width: 110, align: "right", type: "number" },
  { key: "kolExp", title: "Расход", dataIndex: "kolExp", width: 110, align: "right", type: "number" },
  { key: "kolEnd", title: "На конец", dataIndex: "kolEnd", width: 120, align: "right", type: "number" }
];

const WarehouseRegister = () => (
  <WarehouseLedger
    kind="register"
    fetchPage={fetchWarehouseRegister}
    normalizeRow={normalizeRegisterRow}
    columns={COLUMNS}
    defaultSortBy="tovName"
  />
);

export default WarehouseRegister;
